import ParticlesPreloader from './ParticlesPreloader';

export default ParticlesPreloader;



// WEBPACK FOOTER //
// ./scripts/elements/ParticlesPreloader/index.js